const routes = [
    {
        path: "/osym/quotas",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "osymquota_index"
        }
    },
];

export default routes;
